import { FETCH_AUTH_ITEMS_SAGA } from "./types/actionTypes";

export const initalApp = () => ({
  type: FETCH_AUTH_ITEMS_SAGA
});